export default "__VITE_ASSET__rxVLD6hE__"